module.exports = __webpack_public_path__ + "media/assets/icons/linkedin-0170f94068bb61834cd87ebbd1f86dfe.svg";